import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getSearchPrograms = (IsSkipduedateProgram, SearchText, Status) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.GROUP_MANAGEMENT.SEARCH_PROGRAMS(
      IsSkipduedateProgram,
      SearchText,
      Status
    ),
    "",
    cancelToken
  );
};

export default getSearchPrograms;
